import { ShoppingCart } from 'components/gruenland/icons/ShoppingCart';

type Props = {
  className?: string;
  totalCartItems?: number;
};

const CartStatusIcon: React.FC<Props> = ({ className, totalCartItems = 0 }) => (
  <div className="relative">
    {totalCartItems > 0 && (
      <span className="absolute right-[-10px] top-[-3px] size-[10px] rounded-full bg-primary-green" />
    )}
    <ShoppingCart className={className} />
  </div>
);

export default CartStatusIcon;
